import 'css-chunksrc/client/common/layout/zonesList/zone/loader/project/styles.scss';export default {
  "header": "_header_uirar_1",
  "main": "_main_uirar_14",
  "name": "_name_uirar_22",
  "tasks": "_tasks_uirar_26",
  "icon": "_icon_uirar_30",
  "listsList": "_listsList_uirar_35"
};